
import {
    Drawer,
    IconButton
} from '@mui/material'
import React from 'react'
import MainMenu from './MainMenu'
import { Icons } from '../../misc/Icons'
import { store } from '../../stores/Store'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import ReportTool from '../views/report/ReportTool'
import AccountTool from '../views/account/AccountTool'
import ProfileTool from '../views/profile/ProfileTool'
import TemplateTool from '../views/template/TemplateTool'
import QuestionnaireTool from '../views/questionnaire/QuestionnaireTool'
import ClientTool from '../views/client/ClientTool'
import ErrorBoundary from '../../misc/ErrorBoundary'
import AutomationLogTool from '../views/automation_log/AutomationLogTool'
import WorkflowTool from '../views/workflow/WorkflowTool'
import CaseSummaryTool from '../views/case_summary/CaseSummaryTool'


export default observer(function ToolDrawer() {

    const {setOpen, open, setTool, tool} = store.ToolStore
    const params = useParams()

    // React.useEffect(() => {
    //     setOpen(false)
    //     setTool(null)
    // }, [params])

    document.onkeyup = (e) => {
        e.ctrlKey && e.key === "m" && setOpen(!open)
    }

    return (
        <React.Fragment>
            <IconButton
                onClick={() => {setOpen(true)}}
                aria-label="Main menu"
                className="main-menu-toggler">
                <Icons.Menu style={{color: "white"}} />
            </IconButton>
 
            <Drawer
                anchor="left"
                open={open}
                role="menu"
                PaperProps={{
                    style: {
                        boxShadow: "none",
                        backgroundColor: "transparent"
                    }
                }}
                onClose={() => {setOpen(false)}}>
                <div className={`tool-drawer ${tool ? "tool-drawer-open" : null}`}>
                    <MainMenu handleClose={() => setOpen(false)} />
                    
                    <div className="tool-drawer-body">
                        <ErrorBoundary>
                            <ToolSwitch />
                        </ErrorBoundary>
                    </div>
                </div>
            </Drawer>
        </React.Fragment>
    )
})


const ToolSwitch = observer(() => {
    switch (store.ToolStore.tool) {
        case "account":
            return <AccountTool />
        case "client":
            return <ClientTool />
        case "profile":
            return <ProfileTool />
        case "report":
            return <ReportTool />
        case "questionnaire":
            return <QuestionnaireTool />
        case "template":
            return <TemplateTool />
        case "automation_log":
            return <AutomationLogTool />
        case "case_summary":
            return <CaseSummaryTool />
        case "workflows":
            return <WorkflowTool />
        default:
            return <></>
    }
})